import Service from "../../Services";

const Banner = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      title: "",
      is_active: true,
      effect: null,
      time_effect: "",
      banner: [],
      branch: [],
      edited_id: ""
      // desktop_images_th: [],
      // mobile_images_th: [],
      // desktop_images_en: [],
      // mobile_images_en: [],
      // URL_banner_th: [],
      // URL_banner_en: []
    },
    edited_id: ""
  },
  mutations: {
    SET_BANNER_ID: (state, res) => {
      state.edited_id = res;
    },
    GET_FORM: (state, res) => {
      state.form.banner = res.banner;
      // state.form.banner.push();
      state.form.id = res.result.id;
      state.form.branch_id = res.result.branch_id;
      state.form.title = res.result.title;
      state.form.is_active = res.result.is_active;
      state.form.effect = res.result.effect;
      state.form.time_effect = res.result.time_effect;
      console.log("resxxx", res);
      console.log("formxxxxx", state.form);
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        title: "",
        is_active: true,
        effect: null,
        time_effect: "",
        banner: [],
        branch: [],
        edited_id: ""
      };
      state.edited_id = "";
    },
    REMOVE_SLIDE_MOBILE_IMAGE_TH: (state, index) => {
      state.form.mobile_images_th = state.form.mobile_images_th.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    REMOVE_SLIDE_DESKTOP_IMAGE_TH: (state, index) => {
      state.form.desktop_images_th = state.form.desktop_images_th.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    REMOVE_SLIDE_MOBILE_IMAGE_EN: (state, index) => {
      state.form.mobile_images_en = state.form.mobile_images_en.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    REMOVE_SLIDE_DESKTOP_IMAGE_EN: (state, index) => {
      state.form.desktop_images_en = state.form.desktop_images_en.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions: {
    getBanner({ commit }, { page, search, sort_date }) {
      return Service.BannerAPI.getBanner(page, search, sort_date);
    },
    showBanner({ commit }, id) {
      commit("SET_BANNER_ID", id);
      console.log("show Id", id);
      return Service.BannerAPI.showBanner(id);
    },
    saveBanner({ commit }, { id, data }) {
      // if (id) {
      //   return Service.BannerAPI.updateBanner(id, data);
      // } else {
      return Service.BannerAPI.createBanner(data);
      // }
    },
    deleteBanner({ commit }, id) {
      return Service.BannerAPI.deleteBanner(id);
    },
    setFormBanner({ commit }, res) {
      console.log("getRes", res);
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      console.log("clear1");
      commit("CLEAR_FORM_DATA");
    },
    removeMobileImage_th({ commit }, index) {
      commit("REMOVE_SLIDE_MOBILE_IMAGE_TH", index);
    },
    removeDesktopImage_th({ commit }, index) {
      commit("REMOVE_SLIDE_DESKTOP_IMAGE_TH", index);
    },
    removeMobileImage_en({ commit }, index) {
      commit("REMOVE_SLIDE_MOBILE_IMAGE_EN", index);
    },
    removeDesktopImage_en({ commit }, index) {
      commit("REMOVE_SLIDE_DESKTOP_IMAGE_EN", index);
    }
  }
};
export default Banner;
